// Resource-related test IDs
export const RESOURCE = {
	sectionTitle: 'resources-section-title',
	card: 'resource-card',
	buyButton: 'resource-buy-button',
	modal: 'resource-modal',
	modalEmailInput: 'resource-modal-email-input',
	modalPayButton: 'resource-modal-pay-button',
	modalClose: 'resource-modal-close',
	successContainer: 'resource-success-container',
	downloadButton: 'resource-download-button',
	filterCategory: 'resource-filter-category',
	filterLevel: 'resource-filter-level',
	filterType: 'resource-filter-type',
	comingSoonBanner: 'resources-coming-soon-banner',
	comingSoonContactLink: 'resources-coming-soon-contact-link',
};

// Admin resource test IDs
export const ADMIN_RESOURCE = {
	titleInput: 'admin-resource-title-input',
	descriptionInput: 'admin-resource-description-input',
	categorySelect: 'admin-resource-category-select',
	levelSelect: 'admin-resource-level-select',
	typeSelect: 'admin-resource-type-select',
	priceInput: 'admin-resource-price-input',
	fileInput: 'admin-resource-file-input',
	submitButton: 'admin-resource-submit-button',
	row: 'admin-resource-row',
	toggleButton: 'admin-resource-toggle-button',
	deleteButton: 'admin-resource-delete-button',
};
